import { IAsyncExpression } from './repository/async/IAsyncExpression';
import { IConditionGroupExpression } from './repository/condition-group/IConditionGroupExpression';
import { IConditionExpression } from './repository/condition/IConditionExpression';
import { IFunctionExpression } from './repository/function/IFunctionExpression';
import { IReferenceExpression } from './repository/reference/IReferenceExpression';
import { ISubconditionsGroupExpression } from './repository/subconditions-group/ISubconditionsGroupExpression';
import { ISwitchExpression } from './repository/switch-expression/ISwitchExpression';
import { IValueExpression } from './repository/value/IValueExpression';

export enum ExpressionType {
  Value = 'value',
  Reference = 'reference',
  Function = 'function',
  Condition = 'condition',
  ConditionGroup = 'conditionGroup',
  Switch = 'switch',
  SubconditionsGroup = 'subconditionsGroup',
  Async = 'async',
}

/**
 * Ogni Espressione possibile deve essere censita qui, a prescindere che sia
 * utilizzata come una regola di validazione o come un campo calcolato. Deve
 * avere sempre un `type` univoco e censito.
 *
 * A livello concettuale, ad esempio, una regola di validazione equivale
 * a un booleano che, se true, esprime un messaggio di errore.
 *
 * Il concetto di espressione è limitato al fatto che **restituisca un unico
 * valore**. Tutto ciò che è più complesso di un valore singolo è gestito
 * da ulteriori strutture dati.
 */
export type IExpression =
  | IValueExpression
  | IReferenceExpression
  | IFunctionExpression
  | IConditionExpression
  | IConditionGroupExpression
  | IAsyncExpression
  | ISubconditionsGroupExpression
  | ISwitchExpression;
